import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import { usePostHog } from "posthog-js/react";
import moment from "moment/moment";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import topicSelectors from "~/store/topics/selectors";
import topicActionCreators from "~/store/topics/actions";
import topicRetroSchema from "~/forms/TopicRetroForm/topicRetroSchema";
import TopicRetroForm from "~/forms/TopicRetroForm";
import Button from "../../components-shared/Button";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const TopicRunRetroModal = () => {
  const {
    t
  } = useTranslation();
  const topic = useSelector(topicSelectors.getSelected);
  const status = useSelector(topicSelectors.getRetroStatus);
  const error = useSelector(topicSelectors.getRetroError);
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const {
    handleSubmit,
    control,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(topicRetroSchema),
    defaultValues: {
      sources: topic?.sources || [],
      dateFrom: undefined,
      dateTo: undefined,
      directMapping: false,
      slackChannels: topic?.settings.slackChannels,
      jiraProjects: topic?.settings.jiraProjects,
      confluenceSpaces: topic?.settings.confluenceSpaces,
      linearTeams: topic?.settings.linearTeams,
      asanaProjects: topic?.settings.asanaProjects,
      githubRepositories: topic?.settings.githubRepositories,
      productboardProducts: topic?.settings.productboardProducts,
      mondayBoards: topic?.settings.mondayBoards
    }
  });
  const onSubmit = handleSubmit(data => {
    if (topic?.id) {
      data.dateFrom = moment(data.dateFrom).startOf("day").toISOString();
      data.dateTo = moment(data.dateTo).endOf("day").toISOString();
      dispatch(topicActionCreators.runRetroStarted(topic.id, data, _ref => {
        let {
          data: response
        } = _ref;
        if (response) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TopicRunRetroModal.retroInProgress"),
            timeout: 10000
          }));
        }
      }));
      posthog.capture(`Topics Retro – Run "${topic?.name}"`, {
        ...data
      });
    }
  });
  const handleCancel = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
    posthog.capture(`Topics Retro – Cancel "${topic?.name}"`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicRunRetroModal.retrospective"),
    onClose: handleCancel,
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(TopicRetroForm, {
    control: control,
    setValue: setValue,
    topic: topic,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicRunRetroModal.runRetro")))));
};
export default TopicRunRetroModal;